import { PropsWithChildren } from 'react'
import Styles from './Loading.module.scss'
import MultiStepStepLayoutStyles from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout.module.scss'

import { Heading } from 'blaze-ui/Heading/Heading'
import { Button } from 'blaze-ui/Button'
import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import { SupportChat } from 'components/FirstTimeExperienceModal/components/SupportChat/SupportChat'
import { Icon } from 'blaze-ui/icons/Types'
import { useIsOnboardingRedesign } from 'hooks/useIsOnboardingRedesign'
import { LoadingProgresses } from './LoadingProgresses'

export type Progress = {
  title: string
  isRunning: boolean
  percentComplete: number
  element?: React.ReactNode
  lineHeight?: number
}

interface Props {
  progresses: Progress[]
  onCancel: () => void
  header?: string
  description?: string
  showSupportButton?: boolean
  backButtonText?: string
  backButtonIcon?: Icon
  backgroundClassName?: string
}

export const Loading = ({
  onCancel,
  progresses,
  children,
  header,
  description,
  showSupportButton = false,
  backButtonText = 'Back',
  backButtonIcon,
  backgroundClassName,
}: PropsWithChildren<Props>) => {
  const isOnboardingRedesign = useIsOnboardingRedesign()

  return (
    <div
      className={cx(Styles.processingContainer, backgroundClassName, {
        [Styles.whiteBackground]: !backgroundClassName,
      })}
      data-testid="processing-container"
    >
      <div className={Styles.processingContent}>
        {children}
        <div className={Styles.textAndControls}>
          <div className={Styles.loadingTextContainer}>
            <div className={Styles.headerAndDescription}>
              {header && !isOnboardingRedesign && <h1 className={MultiStepStepLayoutStyles.title}>{header}</h1>}
              {header && isOnboardingRedesign && <Heading level={1}>{header}</Heading>}
              {description && (
                <div className={Styles.description}>
                  <Text color="var(--dark-40)">{description}</Text>
                </div>
              )}
            </div>
            <LoadingProgresses progresses={progresses} gap={12} />
          </div>
          <div className={Styles.buttonsContainer}>
            {showSupportButton && !isOnboardingRedesign && <SupportChat />}
            <div className={Styles.cancelButton}>
              <Button
                variant="tertiary"
                onPress={onCancel}
                size={isOnboardingRedesign ? 'lg' : 'xl'}
                frontIcon={backButtonIcon}
              >
                {backButtonText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
